<template>
    <div class="text-teaser">
        <h1
            v-if="title"
            v-html="title"
        />
        <h3
            v-if="description"
            v-html="description"
        />
        <div v-if="buttons">
            <Link
                v-for="button in buttons"
                :to="button.url"
                :label="button.label"
                :style="button.style"
                :modal="button.modal"
                :image="button.image"
                v-bind:key="button.id"
            />
        </div>
    </div>
</template>

<script>
import Link from '@/components/Links/Link.vue'

export default {
    name: 'TeaserText',
    components: {
        Link
    },
    props: {
        title: String,
        description: String,
        buttons: Array
    }
}
</script>

<style lang="scss" scoped>
.text-teaser.left {
    text-align: left;
}

.text-teaser.center {
    text-align: center;
}

.text-teaser.right {
    text-align: right;
}

.text-teaser>div {
    margin-top: 30px;

    a+a {
        margin-top: $margin-element;
    }

    a {
        width: 50%;
        margin: auto;
        margin-left: 0;
        display: block;
    }
}

/* Store-badge variant (hero + closing CTA): the two badges sit side
   by side even on mobile (the img height drops to 42px there, see
   global.scss, so both fit a 375px viewport) instead of stacking as
   full-width blocks. */
.text-teaser.mobile-stores-teaser>div {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;

    a,
    a+a {
        width: auto;
        display: inline-block;
        margin: 0;
    }
}

@media (min-width: $mq-small) {
    .text-teaser>div {
        margin-top: 30px;

        a+a {
            margin-top: 0px;
            margin-left: $margin-element;
        }

        a {
            width: auto;
            display: inline-block;
        }
    }
}


@media (min-width: $mq-medium) {
    h1 {
        font-size: 52px;
    }
}
</style>
